import React, { useEffect, useState } from 'react';
import { CheckCircle, AlertTriangle, Loader2 } from 'lucide-react';
import { useSearchParams, Link } from 'react-router-dom';

const API = process.env.REACT_APP_BACKEND_URL;

export default function SurveyFixatePage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');
  const [pdfPath, setPdfPath] = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('Kein Token angegeben.');
      return;
    }
    fixate();
  }, [token]);

  const fixate = async () => {
    setStatus('loading');
    try {
      const url = `${API}/api/surveys/fixate`;
      const d = await new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open('POST', url);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.onload = () => {
          try { resolve(JSON.parse(xhr.responseText)); }
          catch { resolve({ detail: 'Ungültige Antwort' }); }
        };
        xhr.onerror = () => reject(new Error('Network error'));
        xhr.send(JSON.stringify({ token }));
      });
      if (d?.status) {
        setStatus(d.already_fixed ? 'already_fixed' : 'success');
        setMessage(d.message || '');
        if (d.pdf_path) setPdfPath(d.pdf_path);
      } else {
        setStatus('error');
        setMessage(d?.detail || 'Fixierung fehlgeschlagen');
      }
    } catch (err) {
      setStatus('error');
      setMessage('Verbindungsfehler – bitte versuchen Sie es erneut.');
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'var(--bg, #f8fafc)', padding: '2rem 1rem'
    }} data-testid="survey-fixate-page">
      <div style={{
        maxWidth: 480, width: '100%', background: '#fff',
        borderRadius: 12, boxShadow: '0 4px 24px rgba(0,0,0,0.08)', padding: '2.5rem 2rem'
      }}>
        {status === 'loading' && (
          <div style={{ textAlign: 'center', padding: '2rem 0' }}>
            <Loader2 size={32} style={{ animation: 'spin 1s linear infinite', marginBottom: 12, color: '#CC0000' }} />
            <p style={{ fontSize: 14, color: '#6b7280' }}>Meldung wird fixiert...</p>
          </div>
        )}

        {(status === 'success' || status === 'already_fixed') && (
          <div style={{ textAlign: 'center' }}>
            <div style={{
              width: 64, height: 64, borderRadius: '50%', background: '#ecfdf5',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              margin: '0 auto 16px'
            }}>
              <CheckCircle size={32} color="#059669" />
            </div>
            <h2 style={{ fontSize: 20, marginBottom: 8, color: '#111827' }}>
              {status === 'already_fixed' ? 'Bereits fixiert' : 'Erfolgreich fixiert!'}
            </h2>
            <p style={{ fontSize: 14, color: '#6b7280', marginBottom: 16, lineHeight: 1.6 }}>
              {status === 'already_fixed'
                ? 'Ihre Meldung war bereits fixiert. Es ist keine weitere Aktion erforderlich.'
                : 'Ihre Meldung wurde erfolgreich fixiert und kann nicht mehr geändert werden.'}
            </p>
            {pdfPath && (
              <p style={{ fontSize: 13, color: '#6b7280', marginBottom: 16 }}>
                Ein PDF-Beleg wurde in Ihrem Dokumentenbereich abgelegt.
              </p>
            )}
            <Link to="/login" style={{
              display: 'inline-block', padding: '10px 24px', background: '#CC0000',
              color: '#fff', textDecoration: 'none', borderRadius: 6, fontSize: 13, fontWeight: 500
            }} data-testid="fixate-back-link">
              Zum Portal
            </Link>
          </div>
        )}

        {status === 'error' && (
          <div style={{ textAlign: 'center' }}>
            <div style={{
              width: 64, height: 64, borderRadius: '50%', background: '#fef2f2',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              margin: '0 auto 16px'
            }}>
              <AlertTriangle size={32} color="#dc2626" />
            </div>
            <h2 style={{ fontSize: 20, marginBottom: 8, color: '#111827' }}>Fixierung fehlgeschlagen</h2>
            <p style={{ fontSize: 14, color: '#6b7280', marginBottom: 16 }}>{message}</p>
            <Link to="/login" style={{
              display: 'inline-block', padding: '10px 24px', background: '#6b7280',
              color: '#fff', textDecoration: 'none', borderRadius: 6, fontSize: 13, fontWeight: 500
            }} data-testid="fixate-error-link">
              Zum Portal
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
